import { useEffect } from "react";
import { InteractionManager } from "react-native";

interface UseRedirectOnRefreshProps {
  currentRoute: string; 
  redirectRoute: string;
  rnNavigation: (args: { name: string; replace?: boolean }) => void;
}

const isPageReload = (): boolean => {
  if (typeof performance === "undefined" || !performance.getEntriesByType) {
    return false; 
  }
  const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
  return navEntries.length > 0 && navEntries[0].type === "reload";
};

export const useRedirectOnRefresh = ({
  currentRoute,
  redirectRoute,
  rnNavigation,
  skipRedirect = false, 
}: UseRedirectOnRefreshProps & { skipRedirect?: boolean }) => {
  useEffect(() => {
    if (skipRedirect) return; 

    const currentPath = window.location.pathname;
    if (currentPath.includes(currentRoute)) {
      if (isPageReload()) {
        InteractionManager.runAfterInteractions(() => {
          rnNavigation({
            name: redirectRoute,
            replace: true,
          });
        });
      }
    }
  }, [currentRoute, redirectRoute, rnNavigation, skipRedirect]);
};
